export const devLabel = 'DEV VERSION';

export const checkAppVersionCompatibility = (
  appVersion: string,
  backendVersion: string,
) => {
  const [appMajor, appMinor, appPatch] = extractVersionParts(appVersion);
  const [backendMajor, backendMinor, backendPatch] =
    extractVersionParts(backendVersion);

  return (
    appMajor === backendMajor &&
    (appMinor < backendMinor ||
      (appMinor == backendMinor && appPatch <= backendPatch))
  );
};

function extractVersionParts(version: string) {
  return version.split('.').map(Number);
}

export function getMajorVersion(text: string) {
  const m = text.match(/^(\d+)\./);
  return m ? Number(m[1]) : NaN;
}

export function isDevVersion(version: string) {
  const major = getMajorVersion(version);
  return major % 2 === 0;
}
